import fetch from "auth/FetchInterceptor";
import axios from "axios";
import {
  API_BASE_URL,
  API_BASE_URL_V2,
  EVENTS_API_BASE_URL,
} from "configs/AppConfig";

const ViewService = {};

ViewService.getPost = function (params) {
  return fetch({
    url: "/posts/1",
    method: "get",
    params,
  });
};

ViewService.getProductsList = function (params) {
  return fetch({
    url: `${API_BASE_URL}/products`,
    method: "get",
    params,
  });
};

ViewService.addVideo = function (data) {
  return fetch({
    url: `${API_BASE_URL}/videos/create`,
    method: "post",
    data: data,
  });
};

ViewService.uploadUrlInVideo = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/feeds/socialUrl/sync/s3`,
    method: "post",
    data: data,
  });
};

ViewService.addProduct = function (data) {
  return fetch({
    url: `${API_BASE_URL}/products/v2/create`,
    method: "post",
    data: data,
  });
};

ViewService.addProductMulti = function (data) {
  return fetch({
    url: `${API_BASE_URL}/products/v2/create/multi`,
    method: "post",
    data: data,
  });
};

ViewService.addPLPCategory = function (data) {
  return fetch({
    url: `${API_BASE_URL}/plp-category/create`,
    method: "post",
    data: data,
  });
};

ViewService.EditPlpCategory = function (data) {
  return fetch({
    url: `${API_BASE_URL}/plp-category/plp-category-update`,
    method: "post",
    data: data,
  });
};

ViewService.addMultiplePLPCategory = function (data) {
  return fetch({
    url: `${API_BASE_URL}/plp-category/create/multi`,
    method: "post",
    data: data,
  });
};

ViewService.deletePlpCategory = function (data) {
  return fetch({
    url: `${API_BASE_URL}/plp-category/delete`,
    method: "delete",
    data: data,
  });
};

ViewService.getPlpCategory = (params) => {
  return fetch({
    url: `${API_BASE_URL}/plp-category`,
    method: "get",
    params,
  });
};

ViewService.getVideos = function (params) {
  return fetch({
    url: `${API_BASE_URL}/videos`,
    method: "get",
    params,
  });
};

ViewService.deleteVideoFeed = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/feeds/delete`,
    method: "delete",
    data,
  });
};

ViewService.generateRoom = function (data) {
  return fetch({
    url: `${API_BASE_URL}/call/video/generate/room`,
    method: "post",
    data: data,
  });
};

ViewService.generateTokenForRoom = function (data) {
  return fetch({
    url: `${API_BASE_URL}/call/video/generate/call-token`,
    method: "post",
    data: data,
  });
};

ViewService.updateRoomStatus = function (data) {
  return fetch({
    url: `${API_BASE_URL}/call/video/update/room`,
    method: "post",
    data: data,
  });
};
ViewService.ongoingCall = function () {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/ongoing`,
    method: "get",
  });
};

ViewService.isOngoingCall = function (params) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/is-ongoing`,
    method: "get",
    params,
  });
};

ViewService.changeDevice = function (data) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/change/device`,
    method: "post",
    data: data,
  });
};

ViewService.isDeviceChange = function (data) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/is/device-change`,
    method: "post",
    data: data,
  });
};

ViewService.getScheduleCallId = function (params) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/security-token/decrypt`,
    method: "get",
    params,
  });
};

ViewService.getProducts = function (params) {
  return fetch({
    url: `${API_BASE_URL}/products`,
    method: "get",
    params,
  });
};

ViewService.deleteProduct = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/products/delete`,
    method: "delete",
    data,
  });
};

ViewService.updateVideo = function (data) {
  return fetch({
    url: `${API_BASE_URL}/videos/update`,
    method: "post",
    data: data,
  });
};

ViewService.getShoppableFeed = function (params) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds`,
    method: "get",
    params,
  });
};

ViewService.getWidgetList = function (params) {
  return fetch({
    url: `${API_BASE_URL}/widget`,
    method: "get",
    params,
  });
};

ViewService.getPLPWidgetList = function (id, params) {
  return fetch({
    url: `${API_BASE_URL_V2}/widget/collection/${id}`,
    method: "get",
    params,
  });
};

ViewService.getFeedList = function (id, params) {
  return fetch({
    url: `${API_BASE_URL}/widget/shoppable-feeds/${id}`,
    method: "get",
    params,
  });
};

ViewService.getStoryList = function (id, params) {
  return fetch({
    url: `${API_BASE_URL}/widget/story/${id}`,
    method: "get",
    params,
  });
};

ViewService.getFeeds = function (params) {
  return fetch({
    url: `${API_BASE_URL}/feeds`,
    method: "get",
    params,
  });
};

ViewService.addFeed = function (data) {
  return fetch({
    url: `${API_BASE_URL}/feeds/create`,
    method: "post",
    data: data,
  });
};

ViewService.createShoppableFeed = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/v2/create`,
    method: "post",
    data: data,
  });
};

ViewService.updateFeed = function (data) {
  return fetch({
    url: `${API_BASE_URL}/feeds/update`,
    method: "put",
    data: data,
  });
};

ViewService.deleteShoppableFeed = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/delete`,
    method: "delete",
    data: data,
  });
};

ViewService.shoppableFeedUpdate = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/v2/update`,
    method: "put",
    data: data,
  });
};

ViewService.getFormList = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/forms`,
    method: "get",
    params,
  });
};

ViewService.deleteForm = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/delete-form`,
    method: "delete",
    params,
  });
};

ViewService.createForm = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/create-form`,
    method: "post",
    data,
  });
};

ViewService.updateForm = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/update-form`,
    method: "put",
    data: data,
  });
};

ViewService.genrateCSVForm = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/generateforms`,
    method: "post",
    data,
  });
};

ViewService.editProduct = function (data) {
  return fetch({
    url: `${API_BASE_URL}/products/update`,
    method: "put",
    data: data,
  });
};

ViewService.getScheduleCall = function (params, status) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/status/${status}`,
    method: "get",
    params,
  });
};

ViewService.getInstantCall = function (params, status) {
  return fetch({
    url: `${API_BASE_URL}/instantcall/status/${status}`,
    method: "get",
    params,
  });
};

ViewService.getInstantCallUserInfo = function (params) {
  return fetch({
    url: `${API_BASE_URL}/conferenceUsers/get-customer-info`,
    method: "get",
    params,
  });
};

ViewService.postUpdateCallStatus = function (data) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/instant-call/update`,
    method: "post",
    data: data,
  });
};

ViewService.scheduleCallInvitation = function (data) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/call-invitation`,
    method: "post",
    data: data,
  });
};

ViewService.updateScheduleCallStatus = function (data) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/update`,
    method: "post",
    data: data,
  });
};

ViewService.missedCalls = function (params) {
  return fetch({
    url: `${API_BASE_URL}/conferenceUsers/missed/calls`,
    method: "post",
    params,
  });
};

ViewService.updateConferenceUser = function (data) {
  return fetch({
    url: `${API_BASE_URL}/conferenceUsers/update-conference-user`,
    method: "post",
    data: data,
  });
};

ViewService.addAgentDetails = function (data) {
  return fetch({
    url: `${API_BASE_URL}/user/addUser`,
    method: "post",
    data: data,
  });
};

ViewService.getAgentDetails = function () {
  return fetch({
    url: `${API_BASE_URL}/user/get-users`,
    method: "get",
  });
};

ViewService.getLocations = function () {
  return fetch({
    url: `${API_BASE_URL}/company/warehouses`,
    method: "get",
  });
};

//influencers api

ViewService.getAllOnboardedInfluencers = function () {
  return fetch({
    url: `${API_BASE_URL}/plugin/influencers`,
    method: "get",
  });
};

ViewService.sentInvitationLink = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/influencers/influencer-invitation`,
    method: "get",
    params: params,
  });
};

ViewService.acceptInvitationLink = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/influencers/influencer-hiring`,
    method: "post",
    data: data,
  });
};

ViewService.getAcceptedCompanies = function () {
  return fetch({
    url: `${API_BASE_URL_V2}/influencers/get-company-list`,
    method: "get",
  });
};

//influencers api

ViewService.getAllOnboardedInfluencers = function () {
  return fetch({
    url: `${API_BASE_URL}/plugin/influencers`,
    method: "get",
  });
};

ViewService.sentInvitationLink = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/influencers/influencer-invitation`,
    method: "get",
    params: params,
  });
};

ViewService.getAcceptedCompanies = function () {
  return fetch({
    url: `${API_BASE_URL_V2}/influencers/get-company-list`,
    method: "get",
  });
};

ViewService.getInfluencerCompany = function () {
  return fetch({
    url: `${API_BASE_URL_V2}/influencers/get-influencer-company`,
    method: "get",
  });
};

ViewService.switchInfluencerCompany = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/influencers/switch-company`,
    method: "get",
    params,
  });
};

ViewService.addLocation = function (data) {
  return fetch({
    url: `${API_BASE_URL}/company/warehouse`,
    method: "post",
    data: data,
  });
};

ViewService.updateLocation = function (data) {
  return fetch({
    url: `${API_BASE_URL}/company/warehouse`,
    method: "put",
    data: data,
  });
};

ViewService.updateAgentDetails = function (data) {
  return fetch({
    url: `${API_BASE_URL}/user/update-user`,
    method: "post",
    data: data,
  });
};

ViewService.deleteAgentDetails = function (data) {
  return fetch({
    url: `${API_BASE_URL}/user/delete-user`,
    method: "post",
    data: data,
  });
};

ViewService.getRoleId = function () {
  return fetch({
    url: `${API_BASE_URL}/user/getRole`,
    method: "get",
  });
};

ViewService.getCompanyInfo = function () {
  return fetch({
    url: `${API_BASE_URL}/company/info`,
    method: "get",
  });
};

ViewService.getCurrencyCode = function () {
  return fetch({
    url: `${API_BASE_URL}/currency`,
    method: "get",
  });
};

ViewService.updateCompany = function (data) {
  return fetch({
    url: `${API_BASE_URL}/company/update `,
    method: "put",
    data: data,
  });
};
ViewService.oneToOneCallHistory = function (params) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/call/history`,
    method: "get",
    params,
  });
};

ViewService.getConferenceUsersInfo = function (params) {
  return fetch({
    url: `${API_BASE_URL}/conferenceUsers/call/history`,
    method: "get",
    params,
  });
};
ViewService.getOneToOneAnalyticsInfo = function () {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/company/analytics`,
    method: "get",
  });
};

ViewService.postCSVFile = function (data) {
  return fetch({
    url: `${API_BASE_URL}/products/upload-file-to-s3`,
    method: "post",
    data: data,
  });
};

ViewService.postCSVFileShoppableFeed = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/create-shoppable-feed-csv-upload`,
    method: "post",
    data: data,
  });
};

ViewService.getImportInfo = function (params) {
  return fetch({
    url: `${API_BASE_URL}/products/get-jobs`,
    method: "get",
    params,
  });
};

ViewService.markAsFinsihedCall = function (data) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/finish`,
    method: "put",
    data: data,
  });
};

// ViewService.getShoppableFeedsAnalytics = function (path) {
//     return fetch({
//         url: `${API_BASE_URL}/sf/analytics/time/${path}`,
//         method: 'get',
//     })
// }

ViewService.postInstaAuthCode = function (params) {
  return fetch({
    url: `${API_BASE_URL}/instagram/auth`,
    method: "post",
    params,
  });
};

ViewService.postInstaFeeds = function () {
  return fetch({
    url: `${API_BASE_URL}/instagram/import-feeds`,
    method: "post",
  });
};

ViewService.postInstaOauthData = function (data) {
  return fetch({
    url: `${API_BASE_URL}/feeds/save-shopify-oauth`,
    method: "post",
    data: data,
  });
};

ViewService.postStoreInfo = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/shopify/marketplace-credentials`,
    method: "post",
    data: data,
  });
};

ViewService.getStoreConfiguration = function () {
  return fetch({
    url: `${API_BASE_URL}/shopify/get-shopify-credentials`,
    method: "get",
  });
};

ViewService.registerWebhook = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shopify/register-webhook`,
    method: "post",
    data: data,
  });
};

ViewService.deleteWebhook = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shopify/delete-webhook`,
    method: "post",
    data: data,
  });
};

ViewService.checkStatusWebhook = function (params) {
  return fetch({
    url: `${API_BASE_URL}/shopify/check-webhook`,
    method: "get",
    params,
  });
};

ViewService.getShoppableWatchTime = function (params) {
  return fetch({
    url: `${API_BASE_URL}/feeds/calculate-feed-time`,
    method: "get",
    params,
  });
};
ViewService.getCustomerQuestions = function (params) {
  return fetch({
    url: `${API_BASE_URL}/qna/customer/questions`,
    method: "get",
    params,
  });
};
ViewService.postFAQ = function (data) {
  return fetch({
    url: `${API_BASE_URL}/qna/faq`,
    method: "post",
    data: data,
  });
};
ViewService.getFAQ = function () {
  return fetch({
    url: `${API_BASE_URL}/qna/cms/faqs`,
    method: "get",
  });
};
ViewService.getSfAnalytics = function (params) {
  return fetch({
    url: `${API_BASE_URL}/sf/analytics`,
    method: "get",
    params,
  });
};

ViewService.getAttachedShoppableFeed = function (params) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/cms/product/v2`,
    method: "get",
    params,
  });
};

ViewService.getAttachedShoppableFeedPip = function (params) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/cms/v3`,
    method: "get",
    params,
  });
};

ViewService.updateAttachedShoppableFeed = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/pdp/rank`,
    method: "put",
    data: data,
  });
};

ViewService.productSync = function (data) {
  return fetch({
    url: `${API_BASE_URL}/products/sync/shopify`,
    method: "post",
    data: data,
  });
};

ViewService.getTags = function () {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/tags`,
    method: "get",
  });
};

ViewService.postTags = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/tags`,
    method: "post",
    data: data,
  });
};

ViewService.postStoryInfo = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/story/create`,
    method: "post",
    data: data,
  });
};

ViewService.getStories = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/story`,
    method: "get",
    params,
  });
};

ViewService.deleteStory = function (params) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/story/delete`,
    method: "delete",
    params,
  });
};

ViewService.editStory = function (data, params) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/story/update`,
    method: "post",
    data: data,
    params,
  });
};

ViewService.getCompanyOneToOnePlugin = function (params) {
  return fetch({
    url: `${API_BASE_URL}/conferenceUsers/getCompanyInfo`,
    method: "get",
    params,
  });
};

ViewService.getShoppableFeedConfiguration = function (params) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/configuration/${params.company_id}`,
    method: "get",
    // params,
  });
};

ViewService.updateShoppableFeedConfigurationV2 = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/configuration`,
    method: "put",
    data: data,
    // params,
  });
};

ViewService.getShoppableFeedConfigurationV2 = function (
  company_id,
  layout_id,
  widget_id
) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/configuration/${company_id}?layout_uuid=${layout_id}${
      widget_id != undefined ? `&widget_uuid=${widget_id}` : ""
    }`,
    method: "get",
    // params,
  });
};

ViewService.getLayoutsV1 = function () {
  return fetch({
    url: `${API_BASE_URL}/widget/global/configuration`,
    method: "get",
    // params,
  });
};

ViewService.getProductWiseAnalytics = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/top-performing-products-view-more`,
    method: "get",
    params,
  });
};

ViewService.getWidgetWiseAnalytics = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/top-widgets-view-more`,
    method: "get",
    params,
  });
};

ViewService.getFeedWiseAnalytics = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/top-feeds-view_more`,
    method: "get",
    params,
  });
};

ViewService.getFonts = function (params) {
  return fetch({
    url: `${API_BASE_URL}/helper/get-font`,
    method: "get",
    params,
  });
};

ViewService.postOneToOneCustomizationInfo = function (data) {
  return fetch({
    url: `${API_BASE_URL}/company/call-plugin-configuration`,
    method: "put",
    data: data,
  });
};

ViewService.postShoppableFeedsCustomizationInfo = function (data) {
  return fetch({
    url: `${API_BASE_URL}/company/shoppable-feed-configuration`,
    method: "post",
    data: data,
  });
};

ViewService.updateShoppableFeedsCustomizationInfo = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/configuration`,
    method: "put",
    data: data,
  });
};

ViewService.updateStoryCustomization = function (data) {
  return fetch({
    url: `${API_BASE_URL}/company/story-configuration`,
    method: "post",
    data: data,
  });
};

ViewService.getBadge = function () {
  return fetch({
    url: `${API_BASE_URL}/badge`,
    method: "get",
  });
};

ViewService.getBadge = function () {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds`,
    method: "get",
  });
};

ViewService.createWidget = function (data) {
  return fetch({
    url: `${API_BASE_URL}/widget/create`,
    method: "post",
    data: data,
  });
};

ViewService.getInteractivePipId = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/widget/interactive-pip/create`,
    method: "post",
    data: data,
  });
};

ViewService.addQuestionInteractivePIP = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/widget/interactive-pip/add-question`,
    method: "post",
    data: data,
  });
};

ViewService.updateInteractivePIP = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/widget/interactive-pip/update`,
    method: "post",
    data: data,
  });
};

ViewService.getInteractivePipData = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/widget/interactive-pip`,
    method: "get",
    params: params,
  });
};

//new Interactive PIP Api

ViewService.createInteractivePIPWidget = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/interactive-pip/create`,
    method: "post",
    data: data,
  });
};

ViewService.updateInteractivePIPWidget = function (data, widgetId) {
  return fetch({
    url: `${API_BASE_URL_V2}/interactive-pip/update/${widgetId}`,
    method: "post",
    data: data,
  });
};

ViewService.getInteractivePipResponse = function (widgetId) {
  return fetch({
    url: `${API_BASE_URL_V2}/interactive-pip/fetch/${widgetId}`,
    method: "get",
  });
};

ViewService.addInteractivePIPQuestion = function (data, widgetId) {
  return fetch({
    url: `${API_BASE_URL_V2}/interactive-pip/add-questions/${widgetId}`,
    method: "post",
    data: data,
  });
};

ViewService.updateInteractivePIPQuestion = function (data, widgetId) {
  return fetch({
    url: `${API_BASE_URL_V2}/interactive-pip/update-question/${widgetId}`,
    method: "post",
    data: data,
  });
};

ViewService.deleteInteractivePIPQuestion = function (data, widgetId) {
  return fetch({
    url: `${API_BASE_URL_V2}/interactive-pip/delete-question/${widgetId}`,
    method: "delete",
    data: data,
  });
};

//

ViewService.updateWidget = function (data) {
  return fetch({
    url: `${API_BASE_URL}/widget/update`,
    method: "post",
    data: data,
  });
};

ViewService.deleteWidget = function (data) {
  return fetch({
    url: `${API_BASE_URL}/widget/delete`,
    method: "post",
    data: data,
  });
};

ViewService.generateWidget = function (params) {
  return fetch({
    url: `${API_BASE_URL}/widget/generate-widget-code`,
    method: "get",
    params,
  });
};

ViewService.generateScriptForWidget = function (params) {
  return fetch({
    url: `${API_BASE_URL}/scripts/generate-script`,
    method: "get",
    params,
  });
};

ViewService.getWidgets = function (params) {
  return fetch({
    url: `${API_BASE_URL}/widget/feeds`,
    method: "get",
    params,
  });
};

ViewService.getEngagementAnalytics = function (params) {
  return fetch({
    url: `https://event.lively.li/api/streaming/engagement`,
    method: "get",
    params,
  });
};

ViewService.getEngagementAnalyticsSFWise = function (params) {
  return fetch({
    url: `https://event.lively.li/api/streaming/shoppable-feed-engagement`,
    method: "get",
    params,
  });
};

ViewService.getEngagementAnalyticsWidgetWise = function (params) {
  return fetch({
    url: `https://event.lively.li/api/streaming/widget-engagement?`,
    method: "get",
    params,
  });
};

ViewService.getSalesAnalytics = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/top_analytics`,
    method: "get",
    params,
  });
};

ViewService.getSalesAnalyticsWidget = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/widget-details-analytics-page`,
    method: "get",
    params,
  });
};

ViewService.getSalesAnalyticsSf = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/shoppable-feed-details-analytics-page`,
    method: "get",
    params,
  });
};

ViewService.getTopProductSales = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/top-performing-products`,
    method: "get",
    params,
  });
};

ViewService.getTopWidgetSales = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/top-widgets`,
    method: "get",
    params,
  });
};

ViewService.getTopFeedsSales = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/top-feeds`,
    method: "get",
    params,
  });
};

ViewService.getTopProductEngagement = function (params) {
  return fetch({
    url: `https://event.lively.li/api/streaming/top-products`,
    method: "get",
    params,
  });
};
ViewService.getFunnelData = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/funnel-api`,
    method: "get",
    params,
  });
};

ViewService.getFunnelDataSFWise = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/shoppable-feed-funnel-api`,
    method: "get",
    params,
  });
};

ViewService.getFunnelDataWidgetWise = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/widget-funnel-api`,
    method: "get",
    params,
  });
};

ViewService.getWidgetsAnalytics = function (params) {
  return fetch({
    url: `${API_BASE_URL}/sf/analytics/analytics`,
    method: "get",
    params,
  });
};

ViewService.getMetricAnalytics = function (params) {
  return fetch({
    url: `${API_BASE_URL}/sf/analytics/metric-analytics`,
    method: "get",
    params,
  });
};

ViewService.getTopMetricAnalytics = function (params) {
  return fetch({
    url: `${API_BASE_URL}/sf/analytics/top-metrics`,
    method: "get",
    params,
  });
};

ViewService.changeStatus = function (data) {
  return fetch({
    url: `${API_BASE_URL}/user/change/status`,
    method: "put",
    data: data,
  });
};

ViewService.getTopWidgets = function (params) {
  return fetch({
    url: `${API_BASE_URL}/sf/analytics/top_widget_view_more`,
    method: "get",
    params,
  });
};

ViewService.getTopFeeds = function (params) {
  return fetch({
    url: `${API_BASE_URL}/sf/analytics/top_feeds_view_more`,
    method: "get",
    params,
  });
};

ViewService.sendCmsLogs = function (payload) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/cms/logs`,
    method: "post",
    data: payload,
  });
};

//Live Streaming Services

//Create Live Stream
ViewService.createLiveStream = function (payload) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming`,
    method: "post",
    data: payload,
  });
};

//Get Live Stream Info
ViewService.getLiveStreamInfo = function (params, status) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/status/${status}`,
    method: "get",
    params,
  });
};

ViewService.getLiveStreamInfoByID = function (id) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/${id}`,
    method: "get",
  });
};

ViewService.getLiveStreamConfiguration = function (id) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/cms/configuration`,
    method: "get",
  });
};

ViewService.updateConfigurationLiveStream = function (data) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/configuration/update`,
    method: "put",
    data,
  });
};

//mark as finished api for one 2 many  live-streaming/end
ViewService.updateStreamStatus = function (data) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/end`,
    method: "put",
    data,
  });
};

ViewService.getThumbailUrl = function (params) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/upload/thumbnail`,
    method: "get",
    params,
  });
};

//Generate Zeego Token
ViewService.generateZeegoToken = function (payload) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/token`,
    method: "post",
    data: payload,
  });
};

//Set Streaming Status
ViewService.changeStreamingStatus = function (data) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming`,
    method: "put",
    data: data,
  });
};

//Set Streaming Status
ViewService.getHostPublisghingRights = function (id) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/verify-host/${id}`,
    method: "get",
  });
};

//Get Facebook auth status
ViewService.getFacebookAuthStatus = function (id) {
  return fetch({
    url: `${API_BASE_URL}/facebook/auth`,
    method: "get",
  });
};

//update access token for facebook authentication
ViewService.updateAccessDetailsFacebook = function (payload) {
  return fetch({
    url: `${API_BASE_URL}/facebook/auth`,
    method: "post",
    data: payload,
  });
};
ViewService.getFacebookAccessTokenForLivestream = function (id) {
  return fetch({
    url: `${API_BASE_URL}/facebook/token/${id}`,
    method: "get",
  });
};
ViewService.getFacebookAccessTokenForLivestreamMulti = function (id, auth_id) {
  return fetch({
    url: `${API_BASE_URL}/facebook/v1/token/${id}/${auth_id}`,
    method: "get",
  });
};
ViewService.deleteUserFacebookAuth = function (data) {
  return fetch({
    url: `${API_BASE_URL}/facebook/user/auth`,
    method: "delete",
    data: data,
  });
};

ViewService.checkFacebookPagesSession = function (data, platform) {
  return fetch({
    url: `${API_BASE_URL}/social-platform/check-session/${platform}`,
    method: "post",
    data: data,
  });
};

//instagram stream data check

ViewService.checkInstagramData = function (payload) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/ingest/rtmp`,
    method: "post",
    data: payload,
  });
};

//youtube authentication

ViewService.getYouTubeAuthStatus = function () {
  return fetch({
    url: `${API_BASE_URL}/youtube/auth`,
    method: "get",
  });
};

ViewService.getYouTubeAuthUrl = function () {
  return fetch({
    url: `${API_BASE_URL}/youtube/auth-url`,
    method: "get",
  });
};

ViewService.updateTokenYoutube = function (data) {
  return fetch({
    url: `${API_BASE_URL}/youtube/auth`,
    method: "post",
    data,
  });
};

ViewService.deleteYoutTubeAuth = function (data) {
  return fetch({
    url: `${API_BASE_URL}/youtube/user/auth`,
    method: "delete",
    data,
  });
};

ViewService.getYoutubeAccessTokenForLivestream = function (id) {
  return fetch({
    url: `${API_BASE_URL}/youtube/token/${id}`,
    method: "get",
  });
};

ViewService.getYoutubeChatId = function (token, yt_video_id) {
  return axios.get("https://www.googleapis.com/youtube/v3/liveBroadcasts", {
    params: {
      part: "snippet",
      id: yt_video_id,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

ViewService.getYoutubeChatResponse = function (params, accessToken) {
  return axios.get("https://www.googleapis.com/youtube/v3/liveChat/messages", {
    params: params,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

ViewService.postYoutubeComment = function (payload, youtubeToken) {
  return axios.post(
    "https://www.googleapis.com/youtube/v3/liveChat/messages?part=snippet",
    payload,
    {
      headers: {
        Authorization: `Bearer ${youtubeToken}`,
      },
    }
  );
};

ViewService.brokerQueue = function (data) {
  return fetch({
    url: `${EVENTS_API_BASE_URL}/broker/queue`,
    method: "post",
    data: data,
  });
};

ViewService.postLivestreamComments = function (data) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/comments`,
    method: "post",
    data: data,
  });
};
ViewService.getLivestreamComments = function (params) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/comments`,
    method: "get",
    params,
  });
};

ViewService.postProductChangeTimestamp = function (data) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/insert-time-stamp`,
    method: "post",
    data,
  });
};

ViewService.getCountryCode = function () {
  return fetch({
    url: `${API_BASE_URL}/plugin/company/country-code`,
    method: "get",
  });
};
ViewService.getPurpose = function () {
  return fetch({
    url: `${API_BASE_URL}/plugin/company/lively-products`,
    method: "get",
  });
};

ViewService.getPlatforms = function () {
  return fetch({
    url: `${API_BASE_URL}/plugin/company/platform`,
    method: "get",
  });
};

ViewService.getTutorialInfo = function () {
  return fetch({
    url: `${API_BASE_URL}/cms/company/tutorial`,
    method: "get",
  });
};

//shopify plans

ViewService.checkOnboardedOrNot = function (params) {
  return fetch({
    url: `${API_BASE_URL}/plugin/company/onboarded`,
    method: "get",
    params,
  });
};

ViewService.getShopifyPlans = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/subscription/view/plans`,
    method: "get",
    params,
  });
};

ViewService.createSubscription = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/subscription/create`,
    method: "post",
    data: data,
  });
};

ViewService.verifySubscriptionToken = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/subscription/verify`,
    method: "post",
    data: data,
  });
};

ViewService.refreshToken = function () {
  return fetch({
    url: `${API_BASE_URL_V2}/company/refresh/token`,
    method: "get",
  });
};

//appsumo

ViewService.getCurrentPlanAppsumo = function () {
  return fetch({
    url: `${API_BASE_URL}/app-sumo/check-plan`,
    method: "get",
  });
};

ViewService.getAttachedStory = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/story/pdp`,
    method: "get",
    params,
  });
};

ViewService.updateAttachedStory = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/story/pdp/rank`,
    method: "put",
    data: data,
  });
};

// raise a query

ViewService.raiseQuery = function (data) {
  return fetch({
    url: `${API_BASE_URL}/user/user-query`,
    method: "post",
    data: data,
  });
};

//AGENCY LOGIN

ViewService.getAcceptedCompaniesAGGREGATOR = function () {
  return fetch({
    url: `${API_BASE_URL_V2}/company/get-childs`,
    method: "get",
  });
};

ViewService.switchChildCompany = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/company`,
    method: "get",
    params,
  });
};

ViewService.sentAggregatorMail = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/company/invitation`,
    method: "post",
    data: data,
  });
};

ViewService.acceptInvitationAggregator = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/company/integration`,
    method: "post",
    data: data,
  });
};

//quizz

ViewService.getQuizes = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/quizs`,
    method: "get",
    params,
  });
};

ViewService.createQuiz = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/create-quiz`,
    method: "post",
    data: data,
  });
};

ViewService.updateQuiz = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/update-quiz`,
    method: "put",
    data: data,
  });
};

ViewService.deleteQuiz = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/delete-quiz`,
    method: "delete",
    params,
  });
};

//polls

ViewService.getPolls = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/polls`,
    method: "get",
    params,
  });
};

ViewService.createPoll = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/create-poll`,
    method: "post",
    data: data,
  });
};

ViewService.updatePoll = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/update-poll`,
    method: "put",
    data: data,
  });
};

ViewService.deletePoll = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/delete-poll`,
    method: "delete",
    params,
  });
};

ViewService.getUsersStats = function () {
  return fetch({
    url: `${API_BASE_URL_V2}/user/call/status`,
    method: "get",
  });
};

//admin analytics

ViewService.getAdminAnalytics = function (params) {
  return fetch({
    url: `${EVENTS_API_BASE_URL}/analytics/v2/admin/view/analytics`,
    method: "get",
    params,
  });
};

//Scaling Views
ViewService.updateScaling = function (data) {
  return fetch({
    url: `${API_BASE_URL}/company/shoppable-feed-configuration/scale`,
    method: "post",
    data: data,
  });
};

//get promocode list company wise
ViewService.getPromocodeList = function () {
  return fetch({
    url: `${API_BASE_URL_V2}/subscription/coupons`,
    method: "get",
  });
};

//shopify import
ViewService.getAllProductsImport = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/products/shopify/import`,
    method: "post",
    data,
  });
};

// coupon api

ViewService.getAllCoupons = function () {
  return fetch({
    url: `${API_BASE_URL}/admin/subscription/get-all-coupons`,
    method: "get",
  });
};

ViewService.createCoupon = function (data) {
  return fetch({
    url: `${API_BASE_URL}/admin/subscription/coupon/create`,
    method: "post",
    data: data,
  });
};

ViewService.updateCoupon = function (data) {
  return fetch({
    url: `${API_BASE_URL}/admin/subscription/coupon/update`,
    method: "post",
    data: data,
  });
};

ViewService.deleteCoupon = function (data) {
  return fetch({
    url: `${API_BASE_URL}/admin/subscription/coupon/delete`,
    method: "post",
    data,
  });
};

// AB Testing api

ViewService.updateTesting = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/widget/ab-testing`,
    method: "post",
    data,
  });
};

//accept migration
ViewService.acceptMigration = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/company/sync/shopify/app`,
    method: "post",
    data,
  });
};

//social media post
ViewService.getSMPostList = function (params) {
  return fetch({
    url: `${API_BASE_URL}/social-media/post/queue`,
    method: "get",
    params,
  });
};

ViewService.createSMPost = function (data) {
  return fetch({
    url: `${API_BASE_URL}/social-media/post`,
    method: "post",
    data,
  });
};

// instagram authentication apis

ViewService.checkInstagramSession = function (params) {
  return fetch({
    url: `${API_BASE_URL}/instagram/check-session`,
    method: "get",
    params,
  });
};

ViewService.createInstagramSession = function (data) {
  return fetch({
    url: `${API_BASE_URL}/instagram/session`,
    method: "post",
    data,
  });
};

ViewService.getInstagramPages = function () {
  return fetch({
    url: `${API_BASE_URL}/instagram/auth`,
    method: "get",
  });
};

ViewService.getInstagramLiveStreamToken = function (streamId) {
  return fetch({
    url: `${API_BASE_URL}/instagram/token/${streamId}`,
    method: "get",
  });
};

ViewService.postInstgramComment = function (data) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/instagram/comments`,
    method: "post",
    data,
  });
};

ViewService.deleteInstagramAuth = function (data) {
  return fetch({
    url: `${API_BASE_URL}/instagram/user/auth`,
    method: "delete",
    data,
  });
};

ViewService.generateLivelyFeedsSignedUrl = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/company/generate-signed-url`,
    method: "post",
    data,
    headers: {
      "x-request-domain": "LIVELY",
      "Content-Type": "application/json",
    },
  });
};

//update sf products ranking api
ViewService.updateProductsRanking = function (data, sfId) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/v2/product/rank/${sfId}`,
    method: "post",
    data,
  });
};

//facebook group api live stream
ViewService.getFacebookGroups = function () {
  return fetch({
    url: `${API_BASE_URL}/facebook/persistent-key`,
    method: "get",
  });
};

ViewService.deleteFacebookGroup = function (data) {
  return fetch({
    url: `${API_BASE_URL}/facebook/persistent-key`,
    method: "delete",
    data,
  });
};

ViewService.createFacebookGroup = function (data) {
  return fetch({
    url: `${API_BASE_URL}/facebook/persistent-key`,
    method: "post",
    data,
  });
};

//multi instagram apis
ViewService.getInstaProfileFromToken = function (params) {
  return fetch({
    url: `${API_BASE_URL}/instagram/insta-profile`,
    method: "get",
    params,
  });
};

ViewService.validateInstaToken = function (data) {
  return fetch({
    url: `${API_BASE_URL}/instagram/rtmp-token`,
    method: "post",
    data,
  });
};

ViewService.checkInstagramToken = function (data) {
  return fetch({
    url: `${API_BASE_URL}/instagram/rtmp-token`,
    method: "post",
    data,
  });
};

ViewService.checkInstaProfileFromToken = function (params) {
  return fetch({
    url: `${API_BASE_URL}/instagram/check-token`,
    method: "get",
    params,
  });
};

ViewService.getInstagramLiveStreamTokenAuthWise = function (streamId, authId) {
  return fetch({
    url: `${API_BASE_URL}/instagram/v1/token/${streamId}/${authId}`,
    method: "get",
  });
};

ViewService.getInstagramCommentRtmp = function (params) {
  return fetch({
    url: `${API_BASE_URL}/instagram/comments`,
    method: "get",
    params,
  });
};

ViewService.getInstagramHeartBeat = function (params) {
  return fetch({
    url: `${API_BASE_URL}/instagram/check-health`,
    method: "get",
    params,
  });
};

//collection ranking apis
ViewService.getAttachedReelsCollection = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/v3/collection/pdp`,
    method: "get",
    params,
  });
};

ViewService.updateAttachedCollectionReelRanking = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/plp/rank`,
    method: "put",
    data,
  });
};

ViewService.getAttachedStoryCollection = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/story/v3/collection/pdp`,
    method: "get",
    params,
  });
};

ViewService.updateAttachedCollectionStoryRanking = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/story/plp/rank`,
    method: "put",
    data,
  });
};

ViewService.encryptVudioToken = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/company/video-editor/encrypt`,
    method: "post",
    data,
  });
};

export default ViewService;
